// extracted by mini-css-extract-plugin
export var contact = "contact-data-module--contact--G8xNM";
export var headline = "contact-data-module--headline--uEMrg";
export var icon = "contact-data-module--icon--v6i4Y";
export var name = "contact-data-module--name--WU3a2";
export var nameTitleWrapper = "contact-data-module--name-title-wrapper--pMuaZ";
export var phone = "contact-data-module--phone--ra8jy";
export var wrapper = "contact-data-module--wrapper--8r-Qh";